import { render, staticRenderFns } from "./Changes.vue?vue&type=template&id=03707d2d"
import script from "./Changes.vue?vue&type=script&lang=js"
export * from "./Changes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports